import { WeScreen } from '@/components/WeScreen/WeScreen'

import { HistoryPlanComponent } from './components/HistoryPlanComponent'
import { SuscriptionPanel } from './components/SuscriptionPanel'

export const BillingAndInvoices = () => {
  return (
    <WeScreen
      useNextButton={false}
      useHeaderBackButton={false}
      useHeader={false}
      customViewStyles="max-sm:p-0"
    >
      <div className="flex flex-col gap-4 mt-4">
        <div>
          <SuscriptionPanel />
          <HistoryPlanComponent />
        </div>
      </div>
    </WeScreen>
  )
}
